import { createTheme } from '@mui/material';

const initialTheme = createTheme();

export const theme = createTheme({
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: 16,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: initialTheme.spacing(40),
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          height: initialTheme.spacing(7),
          minWidth: initialTheme.spacing(28),
        },
      },
    },
  },
  shape: {
    borderRadius: 16,
  },
  typography: {
    fontFamily: [
      'Poppins',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    h1: {
      fontWeight: 700,
      fontSize: 49,
      lineHeight: 1.3,
      letterSpacing: '1px',
      [initialTheme.breakpoints.down('sm')]: {
        fontSize: 29,
      },
    },
    h2: {
      fontWeight: 700,
      fontSize: 39,
      lineHeight: 1.3,
      letterSpacing: '1px',
      [initialTheme.breakpoints.down('sm')]: {
        fontSize: 26,
      },
    },
    h3: {
      fontWeight: 700,
      fontSize: 31,
      lineHeight: 1.3,
      letterSpacing: '1px',
      [initialTheme.breakpoints.down('sm')]: {
        fontSize: 23,
      },
    },
    h4: {
      fontWeight: 700,
      fontSize: 25,
      lineHeight: 1.3,
      letterSpacing: '1px',
      [initialTheme.breakpoints.down('sm')]: {
        fontSize: 20,
      },
    },
    // Pegasus Text large 20 => Text Medium 17
    h5: {
      fontWeight: 700,
      fontSize: 20,
      lineHeight: 1.3,
      letterSpacing: '1px',
      [initialTheme.breakpoints.down('sm')]: {
        fontSize: 18,
      },
    },

    body1: {
      fontSize: 16,
      lineHeight: 1.75,
      letterSpacing: '0.75px',
    },
    body2: {
      fontSize: 14,
      lineHeight: 1.75,
      letterSpacing: '0.75px',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: 0.75,
    },
  },
  palette: {
    background: {
      default: '#FCFCFC',
      paper: '#F7F7FC',
    },
    primary: {
      main: '#6308F7',
      dark: '#2A00A2',
      light: '#EEE5FE',
      contrastText: 'white',
    },
    secondary: {
      main: '#063EF9',
      dark: '#032596',
      light: '#E5EBFE',
      contrastText: 'white',
    },
    offWhite: '#FCFCFC',
  },
} as any);
